// eslint-disable-next-line import/prefer-default-export
export enum queryKeys {
  dashboard = "dashboard",
  account = "account",
  knowledgeBase = "knowledgeBase"
}
